export default __webpack_public_path__ + "static/media/03react.ad42e2dd.png";